// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"302":"book-view","372":"home-view","725":"404-view","855":"books-view"}[chunkId] || chunkId) + "." + {"99":"f5740282","302":"fd94a6d7","372":"c71d45b4","725":"b779de90","855":"491e1c40"}[chunkId] + ".chunk.js";
};